export const DEFAULT_CRM_TOKEN = 'x078pgbue2h';
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/logo.png`;
export const secondaryLogoUrl = `${window.assetsLocation}/images/logo_.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['3'];
export const faqArticleIds = ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'];
